import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHighcharts from '../../CommonComponents/Highcharts';

const ChartsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 1em;

  @media (max-width: 810px) {
    flex-direction: column;
    padding: 0 30px;
  }
`;

const Chart = styled(ReactHighcharts)`
  width: 45%;
  opacity: 1;
  transition: opacity .5s ease;

  ${props => !props.isVisible && `
    position: absolute;
    opacity: 0;
    top: -9999px;
    left: -9999px;
  `}

  @media (max-width: 810px) {
    width: 100%;
  }
`;

const addSelectCategoryAction = (data, action) => ({
  ...data,
  plotOptions: {
    ...data.plotOptions,
    pie: {
      ...data.plotOptions.pie,
      events: {
        click: (e) => {
          action(e.point.name);
        },
      },
    },
  },
});

const CashFlowCharts = ({
  expensesData,
  selectExpensesCategory,
  incomeChart,
  selectIncomeCategory,
}) => (
  <ChartsWrapper>
    <Chart
      autoResize
      options={addSelectCategoryAction(incomeChart.chartData, selectIncomeCategory)}
      isVisible={incomeChart.isVisible}
    />
    <Chart
      autoResize
      options={addSelectCategoryAction(expensesData.chartData, selectExpensesCategory)}
      isVisible={expensesData.isVisible}
    />
  </ChartsWrapper>
);

CashFlowCharts.propTypes = {
  expensesData: PropTypes.shape({}).isRequired,
  selectExpensesCategory: PropTypes.func.isRequired,
  incomeChart: PropTypes.shape({}).isRequired,
  selectIncomeCategory: PropTypes.func.isRequired,
};

export default CashFlowCharts;
